import { IShouldUseCustomDisclaimer } from './types';

export const shouldUseCustomDisclaimer: IShouldUseCustomDisclaimer = () => false;
